import React from 'react';
import {observer} from 'mobx-react';
import {ObservableMap} from 'mobx';
import {Spinner, SpinnerBackgroundColors, SpinnerColors, SpinnerSizes} from '@techsee/techsee-ui-common/lib/spinner';
import {ITimelineItem} from './timeline/contract';
import Timeline from './timeline/Timeline';
import {IExpandedSessionScansValue} from '../controller';

interface ExpandedRowProps {
    sessionId: string;
    scansMap: ObservableMap<string, IExpandedSessionScansValue>;
    loadingMap: ObservableMap<string, boolean>;
    noScansLabel: string;
    onItemClick: (index: number) => void;
    onFetchScans: () => void;
}

@observer
export class ExpandedRow extends React.Component<ExpandedRowProps> {
    componentDidMount() {
        this.props.onFetchScans();
    }

    render() {
        const {sessionId, scansMap, loadingMap, noScansLabel, onItemClick} = this.props;
        const scans = scansMap.get(sessionId);
        const isLoading = loadingMap.get(sessionId);

        if (isLoading || scans === undefined) {
            return (
                <div className='expanded-row-content expanded-row-loading'>
                    <Spinner
                        sizeName={SpinnerSizes.Medium}
                        backgroundColorName={SpinnerBackgroundColors.Transparent}
                        colorName={SpinnerColors.LightGray}
                    />
                </div>
            );
        }

        if (scans.timelineItems.length === 0) {
            return (
                <div className='expanded-row-content'>
                    <p className='no-scans-message'>{noScansLabel}</p>
                </div>
            );
        }

        return (
            <div className='expanded-row-content'>
                <Timeline data={scans.timelineItems} onItemClick={onItemClick} showLabelIcons={true} />
            </div>
        );
    }
}
